import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { PopoverTooltipWithLabel } from '@praktio/common-ui';

import { isCBSSlide } from '../../../utils/slide';
import { WindowSizes } from '../../../utils/constants';
import { RootState } from '../../../ducks/configureStore';

interface IProps {
  dialogue?: string;
  windowSize: string;
}

const Dialogue = ({ dialogue, windowSize }: IProps) => {
  const isCBS = useSelector((state: RootState) =>
    isCBSSlide(state.slidesLitmos.currentSlide?.type),
  );

  return (
    <div
      className={classNames('Dialogue', windowSize, {
        'Dialogue--CBS': isCBS,
      })}
    >
      <div className={classNames('Dialogue-text-wrapper', 'dark-scroll')}>
        <div className={classNames('Dialogue-text', windowSize)}>
          {dialogue}

          {isCBS && (
            <>
              {' '}
              <PopoverTooltipWithLabel
                id="1"
                hasUnderline
                label="HINT: Be specific!"
                iconName="info"
                paragraph="As always with this type of exercise, click the most specific area that's responsive to the prompt."
                placement="right"
                popperConfig={{
                  modifiers: [
                    {
                      name: 'flip',
                      options: {
                        fallbackPlacements: ['bottom'],
                      },
                    },
                    {
                      name: 'preventOverflow',
                      options: {
                        boundary: 'viewport',
                      },
                    },
                  ],
                }}
              />
            </>
          )}
        </div>

        {[WindowSizes.Medium, WindowSizes.Large].includes(windowSize as WindowSizes) && (
          <div className="Dialogue-arrow-left" />
        )}
      </div>
    </div>
  );
};

export default Dialogue;
